module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask-layer mask meQR"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n            为了账号安全，请绑定手机号\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "form_item"
  }, [_c('div', {
    staticClass: "form_left mln12"
  }), _vm._v(" "), _c('div', {
    staticClass: "form_right myRight",
    staticStyle: {
      "width": "unset!important",
      "margin-left": "0px",
      "padding-left": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.model.phone),
      expression: "model.phone",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "myPhone",
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号",
      "name": "phone"
    },
    domProps: {
      "value": (_vm.model.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "phone", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form_item"
  }, [_c('div', {
    staticClass: "form_left mln12"
  }), _vm._v(" "), _c('div', {
    staticClass: "form_right myRight",
    staticStyle: {
      "width": "unset!important",
      "margin-left": "0px",
      "padding-left": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.model.code),
      expression: "model.code",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "myCode",
    attrs: {
      "type": "text",
      "placeholder": "请输入6位验证码",
      "name": "code"
    },
    domProps: {
      "value": (_vm.model.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "code", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.show) ? _c('button', {
    staticClass: "btn mr20",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getMyCode
    }
  }, [_vm._v("获取验证码")]) : _vm._e(), _vm._v(" "), (!_vm.show) ? _c('button', {
    staticClass: "btn mr20",
    staticStyle: {
      "background": "#ccc"
    },
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.count) + "s")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "btn mr20",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("X")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46317ac9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/sendMessage.vue
// module id = u3NV
// module chunks = 4